import { doMutation } from "../../core-module/util/graphqlHelper";

export const deleteTrainingRegistration = id => {
  const mutation = require("../api/mutation/deleteTrainingRegistration.gql");
  const variables = { id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.deleteTrainingRegistration };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
